async function init () {
  globalThis.Bugsnag = await import(
    /* webpackChunkName: "bugsnag" */ '@bugsnag/js'
  )

  globalThis.Bugsnag.start({ apiKey: 'f525a998ce3f526f42c1867256e6830d' })
}

process.env.RAILS_ENV === 'production' && init()
